import {reactive, ref} from 'vue';
import {defineStore} from 'pinia';
import {useRouter} from "vue-router";

export const useSessionStore = defineStore('session', () => {

    const router = useRouter();

    const authorized = ref(false);
    const profile = reactive({
        name: '',
        account: '',
        repr: '',
        admin: false,
    });

    const logout = async () => {
        authorized.value = false;
        await router.push({path: '/login'});
    };

    return {authorized, profile, logout};
});
